var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M19.778 4.222c-4.295-4.296-11.26-4.296-15.556 0-4.296 4.295-4.296 11.26 0 15.556 4.295 4.295 11.26 4.296 15.556 0 4.296-4.296 4.295-11.26 0-15.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M13.434 16.783a1.435 1.435 0 1 1-2.87 0v-5.74a1.435 1.435 0 1 1 2.87 0v5.74zM11.974 8.591c-.826 0-1.377-.585-1.36-1.308-.017-.758.534-1.325 1.377-1.325.844 0 1.377.568 1.395 1.325 0 .723-.551 1.308-1.412 1.308z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4dac2a0cbd9ce4f944fa7ff1fe020e2d.svg";
export { ForwardRef as ReactComponent };